import { render, staticRenderFns } from "./CheckFooter.vue?vue&type=template&id=05ef7bf8"
import script from "./CheckFooter.vue?vue&type=script&lang=js"
export * from "./CheckFooter.vue?vue&type=script&lang=js"
import style0 from "./CheckFooter.vue?vue&type=style&index=0&id=05ef7bf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports